import { Link, LinkButton } from '../buttons';
import DAMBannerCouchGif from 'assets/images/others/dam-banner-couch.gif';
import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

const DAMBannerContainer = styled.div`
    width: 50%;
    padding: 20px;
    background: linear-gradient(90deg, #ffffff 17.59%, #b1efec 100%);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
`;

const DAMBannerLeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 42px;
`;

const DAMBannerLeftTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: black;
    font-family: 'Inter';

    h4 {
        font-weight: 700;
        font-size: 16px;
        padding: 0;
        margin: 0;
    }

    p {
        font-size: 14px;
        padding: 0;
        margin: 0;
    }
`;

const DAMBannerRightContainer = styled.div`
    width: 152px;
    height: 122px;

    img {
        width: 100%;
        height: 100%;
    }
`;

const DAMBanner = () => {
    return (
        <DAMBannerContainer>
            <DAMBannerLeftContainer>
                <DAMBannerLeftTextContainer>
                    <h4>{T._('Try our new Optimization Tool', 'Admin')}</h4>
                    <p>
                        {T._('Analyze your 3D model now to check if optimization is needed for web use.', 'Admin')}{' '}
                        <Link
                            href='https://zakeke.zendesk.com/hc/en-us/articles/18186651154972-3D-Asset-Optimization#01JY6YHEXE5ZSPX5S7XAS4AK3W'
                            target='_blank'
                        >
                            {T._('Learn More', 'Admin')}
                        </Link>
                    </p>
                </DAMBannerLeftTextContainer>

                <LinkButton
                    href='https://zakeke.zendesk.com/hc/en-us/articles/18186651154972-3D-Asset-Optimization#01JY6YHEXE5ZSPX5S7XAS4AK3W'
                    $customWidth='160px'
                    target='_blank'
                >
                    {T._('Discover Now', 'Admin')}
                </LinkButton>
            </DAMBannerLeftContainer>
            <DAMBannerRightContainer>
                <img src={DAMBannerCouchGif} alt='3D Asset Optimization' />
            </DAMBannerRightContainer>
        </DAMBannerContainer>
    );
};

export default DAMBanner;
